<svg
  class="{{ iconColor }} {{ size }}"
  [style.width]="width"
  [style.height]="height"
  [attr.stroke]="stroke"
  [style.fill]="fill">
  <use attr.xlink:href="assets/shared-ui/symbol-defs.svg#{{ icon }}" />
</svg>
